import {Container, Divider, Stack, Typography} from "@mui/material";
import React from "react";
import { explanationFieldData } from "../database/formData";
import { fixedAndCommaNumbers } from "../helper/strings";
import RowList from "./RowList";
import TooltipLocal from "./TooltipLocal";
import { URL_RESULT } from "../database/formData";
const width = window.innerWidth;

function ResultCalcNumberElement(props) {
    return (
        <Container disableGutters={true} sx={{ pt: "3%" }}>
            <RowList
                sx={{ marginY: "10%" }}
                subject={props.subject}
                data={
                    props.value
                        ? fixedAndCommaNumbers(props.value)
                        : "0"
                }
            />

            <Divider sx={{ mt: "3%" }} />
        </Container>
    )
}

function ResultCalc(props) {
  return (
    <Stack>
      <Stack
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: 4,
          paddingBottom: "4%",
          paddingX: width < 580 ? "11%" : "9.4%",
          alignSelf: "center",
          marginBottom: "5%",
        }}
      >
        <Stack
          sx={{
            backgroundColor: "#4C1B72",
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            paddingY: "2%",
            color: "white",
            marginBottom: "13%",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              alignSelf: "center",
              flexGrow: 1,
            }}
          >
            פרמטרים מחושבים
          </Typography>
        </Stack>
        <RowList
          subject="היקף שעות לימוד משוקלל"
          data={props.calcResult.studyHours ? props.calcResult.studyHours : 0}
        />
        <Divider sx={{ marginY: "3%" }} />
        <RowList
          subject="רמה מקצועית משוקללת"
          data={
            props.calcResult.professionalLevel
              ? props.calcResult.professionalLevel
              : "-"
          }
        />
        <Divider sx={{ marginY: "3%" }} />
        <RowList
          subject="ניקוד לתוספת מיקצועית-ניהולית"
          data={
            props.calcResult.scoreAdministrativeProfessional
              ? props.calcResult.scoreAdministrativeProfessional + "%"
              : "0%"
          }
        />
      </Stack>

      <Stack
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: 4,
          paddingBottom: "4%",
          paddingX: "8%",
          alignSelf: "center",
        }}
      >
        <Stack
          sx={{
            backgroundColor: "#4C1B72",
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            paddingY: "2%",
            color: "white",
            marginBottom: "13%",
          }}
          // direction="row"
        >
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              alignSelf: "center",
            }}
          >
            שכר בסיס חדש
          </Typography>
        </Stack>
          <div style={ {
              display: 'grid',
              gridAutoRows: 'auto',
              gridTemplateColumns: "1fr 20fr",
          }} >
              <span>&nbsp;</span>
              <div><ResultCalcNumberElement subject={"שכר יסוד"} value={props.calcResult.basicSalary}/></div>

              <span>&nbsp;</span>
              <div><ResultCalcNumberElement subject={"תוספת ותק לשכר"} value={props.calcResult.senioritySalaryAddition}/></div>

              <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '6px'
              }}><TooltipLocal text={explanationFieldData.newBaseSalary} /></div>
              <div><ResultCalcNumberElement subject={"תוספת עבודה מתוקף מינוי בחוק"} value={props.calcResult.additionalworkVirtueAppointmentLaw}/></div>

              <span>&nbsp;</span>
              <div><ResultCalcNumberElement subject={"תוספת שקלית הסכם מסגרת"} value={props.calcResult.supplementFrameworkAgreement}/></div>

              <div style={{
                  display: 'flex',
                  alignItems: 'center'
              }}> <TooltipLocal text={explanationFieldData.totalPrice} url={URL_RESULT}/></div>
              <div><ResultCalcNumberElement subject={'סה"כ שכר בסיס חדש'} value={props.calcResult.totalSalary}/></div>

          </div>
      </Stack>
    </Stack>
  );
}

export default ResultCalc;
